// SupportDropdown.jsx (Updated for ChatGPT theme)
import React, { useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { Link } from "react-router-dom";
import { FiHelpCircle } from "react-icons/fi";

const SupportDropdown = () => {
  const [menu, setMenu] = useState(false);

  const toggle = () => {
    setMenu(!menu);
  };

  return (
    <Dropdown isOpen={menu} toggle={toggle} className="w-100">
      <DropdownToggle
        className="support-toggle btn btn-link text-decoration-none w-100 text-start px-3 py-2"
        tag="button"
      >
        <FiHelpCircle size={16} className="support-toggle-icon" />
        <span className="support-toggle-text">Help Center</span>
      </DropdownToggle>
      <DropdownMenu
        className="dropdown-menu-dark"
        style={{
          backgroundColor: "#2f2f2f",
          border: "1px solid rgba(255,255,255,0.1)",
          borderRadius: "8px",
          padding: "4px",
        }}
      >
        <DropdownItem
          className="px-3 py-2"
          style={{
            color: "#ececec",
            fontSize: "13px",
            borderRadius: "6px",
          }}
        >
          <Link
            to="/feedback/new"
            className="text-decoration-none"
            style={{ color: "inherit" }}
          >
            Report Issue/Suggestions
          </Link>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default SupportDropdown;
